"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPaymentMethodCode = exports.PAYMENT_METHODS = exports.PAYMENT_METHOD_AMAZONPAY = exports.PAYMENT_METHOD_AFTERPAY = exports.PAYMENT_METHOD_STORECREDIT = exports.PAYMENT_METHOD_GIFTCARD = exports.PAYMENT_METHOD_PAYPAL = exports.PAYMENT_METHOD_CC = void 0;
var typeguards_1 = require("../../typeguards");
exports.PAYMENT_METHOD_CC = 'creditcard';
exports.PAYMENT_METHOD_PAYPAL = 'paypal';
exports.PAYMENT_METHOD_GIFTCARD = 'giftcard';
exports.PAYMENT_METHOD_STORECREDIT = 'storecredit';
exports.PAYMENT_METHOD_AFTERPAY = 'afterpay';
exports.PAYMENT_METHOD_AMAZONPAY = 'amazonpay';
exports.PAYMENT_METHODS = [exports.PAYMENT_METHOD_CC, exports.PAYMENT_METHOD_PAYPAL, exports.PAYMENT_METHOD_GIFTCARD, exports.PAYMENT_METHOD_STORECREDIT, exports.PAYMENT_METHOD_AFTERPAY, exports.PAYMENT_METHOD_AMAZONPAY];
var isPaymentMethodCode = function (input) {
  return (0, typeguards_1.isString)(input) && exports.PAYMENT_METHODS.includes(input);
};
exports.isPaymentMethodCode = isPaymentMethodCode;